import axios from "@axios";
import { hasError } from "@/utils/utils";
export default class {
  list = [];
  options = [];
  indexesKeys;
  ep;
  vue;
  constructor(slug, vue) {
    this.ep = `v2/ministry/indexes/${slug}`;
    this.vue = vue;
  }

  async all() {
    return await axios.get(this.ep).then((res) => {
      if (hasError(res.status)) this.list = [];
      else {
        this.list = res.data.data.records;
        this.options = res.data.data.options;
        if (this.list && this.list[0])
          this.indexesKeys = Object.keys(this.list[0]);
      }
      return res;
    });
  }

  async store(form) {
    return await axios.post(this.ep, form).then((res) => res);
  }

  async update(form) {
    return await axios.put(this.ep + "/" + form.id, form).then((res) => res);
  }

  async delete(id) {
    return await axios.delete(this.ep + "/" + id).then((res) => res);
  }

  getList() {
    return this.list;
  }

  getFields() {
    var fields = [];
    if (this.indexesKeys)
      this.indexesKeys.forEach((element) => {
        var fieldProperties = this.options.find(
          (el) => el.related_name === element
        );
        if (fieldProperties) {
          fields.push({
            key: `${fieldProperties.related_name}.${fieldProperties.related_key_name}`,
            label: this.vue.$t(element),
          });
        } else {
          fields.push({
            key: element,
            label: this.vue.$t(element),
          });
        }
      });
    fields.push({
      key: "actions",
      label: "",
    });
    return fields;
  }

  getFormSchema() {
    var schema = {};
    if (this.indexesKeys)
      this.indexesKeys.forEach((element) => {
        var fieldProperties = this.options.find(
          (el) => el.related_name === element
        );
        if (element === "id" || element === "slug") return;
        else if (element === "icon") {
          schema[element] = {
            key: element,
            component: "IconSelect",
            attrs: {
              rules: "required",
              label: this.vue.$t(element),
            },
          };
        } else if (fieldProperties) {
          schema[fieldProperties.key_name] = {
            key: fieldProperties.key_name,
            component: "FormSelect",
            attrs: {
              label: this.vue.$t(element),
              ep: `v2${fieldProperties.endpoint}`,
              reduce: (x) => x.id,
              getOptionLabel: (x) => x[fieldProperties.related_key_name],
            },
          };
        } else {
          schema[element] = {
            key: element,
            component: "FormInput",
            attrs: {
              rules: "required",
              label: this.vue.$t(element),
            },
          };
        }
      });

    return schema;
  }
}
